import Link from "next/link";
import { customEvent } from "goi_common";

import { NearbyRegion } from "@/utils/regionFacilities";

interface RegionNearbyProps {
  nearbyRegions: NearbyRegion[];
  /** 어느 지역 페이지로 보낼지. 각 섹션 하단에 그 섹션과 같은 종류로 붙인다 */
  kind: "parlor" | "facility";
}

/**
 * 섹션 하단의 인근 지역 링크.
 *
 * 장례식장 섹션 아래에는 인근 지역 장례식장, 장지 섹션 아래에는 인근 지역 장지를
 * 붙인다. 같은 주제의 지역 페이지끼리 이어야 크롤러가 두 갈래(/region/parlor,
 * /region/facility)를 따로 인식한다.
 */
export const RegionNearby = ({ nearbyRegions, kind }: RegionNearbyProps) => {
  const isFacility = kind === "facility";

  // 장지가 없는 시군구의 장지 페이지는 sitemap 에도 없다. 링크도 만들지 않는다
  const regions = isFacility
    ? nearbyRegions.filter((region) => region.hasBurial)
    : nearbyRegions;

  if (!regions.length) return null;

  const suffix = isFacility ? "장지" : "장례식장";
  const titleId = `rg-nearby-${kind}-title`;

  return (
    <nav className="rg-nearby" aria-labelledby={titleId}>
      <h3 id={titleId} className="rg-section__title rg-section__title--sm">
        {`인근 지역 ${suffix}`}
      </h3>

      <ul className="rg-links">
        {regions.map((region) => (
          <li key={`${region.sido}-${region.sigungu}`}>
            <Link
              href={`/region/${kind}/${encodeURIComponent(
                region.sido
              )}/${encodeURIComponent(region.sigungu)}/`}
              className="rg-link"
              onClick={() =>
                customEvent({
                  newGtm: {
                    path: "prlr_region",
                    trigger_and_target: isFacility
                      ? "link_nearby_facility"
                      : "link_nearby",
                  },
                })
              }
            >
              {`${region.sigungu} ${suffix}`}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

/** 페이지 맨 아래 요금 고지. 인근 지역 링크가 섹션별로 흩어지면서 분리했다 */
export const RegionDisclaimer = () => (
  <section className="rg-section rg-section--foot">
    <p className="rg-disclaimer">
      표시된 금액은 각 시설이 공개한 요금표와 지자체 조례를 정리한 것으로, 실제
      청구 금액과 다를 수 있습니다. 장례식장 빈소 사용료는 시설마다 기준 면적과
      기간이 다르며, 화장장과 장지의 관내 요금은 거주 요건을 충족해야
      적용됩니다. 최종 비용은 각 시설에 직접 확인하시기 바랍니다.
    </p>
  </section>
);
